import { componentProvider } from 'js-component-framework';
import FormAssembly from './form-assembly';
import './form-assembly.scss';

const formAssemblyConfig = {
  name: 'form-assembly',
  component: FormAssembly,
};

componentProvider(formAssemblyConfig);
